export const boxStatus = {
    active: 1,
    frozen: 2,
    burned: 3,
}
